import Vue from "vue"
import settings from "./settings"

export function gqlQuery(document, variables = {}) {
    return Vue.http.post(
        settings.graphqlApiUrl,
        JSON.stringify({
            query: document.loc.source.body,
            variables: variables
        }),
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
}

export const gqlMutation = gqlQuery